import React, { Component } from "react";
import { Modal, Input, Row, Col, Form } from "antd";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import { connect } from "react-redux";
import "./style.css";

class UpdateSaleOrderModal extends Component {
  validateValue() {
    const { form } = this.props;
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      return this.props.onOk(values);
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const modalParams = {
      title: "Modify Sale order info",
      visible: this.props.visible,
      onOk: () => this.validateValue(),
      onCancel: () => this.props.onClose(),
    };

    return (
      <Modal {...modalParams}>
        <Form onSubmit={this.validateValue}>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Sale order No.">
                {getFieldDecorator("order_no", {
                  rules: [
                    {
                      pattern: new RegExp(/^SQ-\d{8}$/),
                      message:
                        "Please ensure order_no is the right format (SQ-{8digits}).",
                    },
                  ],
                })(<Input placeholder="SQ-00000000" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Invoice No.">
                {getFieldDecorator("invoice_no", {
                  rules: [
                    {
                      required: true,
                      message: "Please enter invoice-no",
                    },
                    {
                      pattern: new RegExp(/^INV-\d{8}$/),
                      message:
                        "Please ensure invoice-no is the right format (INV-{8digits}).",
                    },
                  ],
                })(<Input placeholder="INV-00000000" />)}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

const formUpdate = Form.create({ name: "sale_order_form_update" })(
  UpdateSaleOrderModal
);

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(formUpdate);



// WEBPACK FOOTER //
// ./src/containers/SaleOrder/UpdateSale.js